import { enumToArray } from "../../helper-functions";

export enum TissueOfferMethod {
    Email = "Email",
    Text = "Text",
    Verbal = "Verbal",
    Fax = "Fax",
}

export const tissueOfferMethods = enumToArray(TissueOfferMethod);
